import React, { Component } from 'react';

export default class DifficultySelectionButton extends Component {
  

    _onClick = () => {

        this.props.onClick(this.props.button_id)
    }

    ifButtonPressed = () => {
        if (this.props.chosen_buttons.includes(this.props.button_id)){
            return {marginRight:"1%", fontFamily:"Montserrat", fontSize:"20px", backgroundColor:"#67D4EF", outline:'none', border:'none'}
        }
        else{
            return {marginRight:"1%", fontFamily:"Montserrat", fontSize:"20px", outline:'none',border:'none'}
        }

        
    }


    render() {
        return (
            <button style={this.ifButtonPressed()} onClick={this._onClick}>{this.props.children}</button>

        )
    }
}